import { render, staticRenderFns } from "./TerminosCondiciones.vue?vue&type=template&id=a47c3e88&scoped=true&"
import script from "./TerminosCondiciones.vue?vue&type=script&lang=js&"
export * from "./TerminosCondiciones.vue?vue&type=script&lang=js&"
import style0 from "./TerminosCondiciones.vue?vue&type=style&index=0&id=a47c3e88&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a47c3e88",
  null
  
)

export default component.exports